import axios from 'axios';
import { Middleware, Context } from '@nuxt/types';

const errorRouteGuard: Middleware = async (context: Context) => {
  if (context.store.state.appSettings.maintenanceMode == null) {
    await context.store.dispatch('appSettings/loadAppSettings');
  }

  if (
    context.store.getters['appSettings/appSettings']?.['maintenanceMode'] &&
    !context.store.getters['user/isInternalUser']
  )
    context.redirect('/maintenance');
};

export default errorRouteGuard;
